var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcTokenPreRemoval = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.25C8.8995 11.25 11.25 8.8995 11.25 6C11.25 3.10051 8.8995 0.75 6 0.75C3.10051 0.75 0.75 3.10051 0.75 6C0.75 8.8995 3.10051 11.25 6 11.25Z",
    fill: "#FFAB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.626 5.17308C9.06092 5.17308 9.4135 5.52566 9.4135 5.96058C9.4135 6.3955 9.06092 6.74808 8.626 6.74808L3.41314 6.748C2.97822 6.748 2.62564 6.39543 2.62564 5.9605C2.62564 5.52558 2.97822 5.173 3.41314 5.173L8.626 5.17308Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcTokenPreRemoval);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_token_Pre_removal.e6ee0e8e8209aa12310e60fdc041c63d.svg";